export const DASHBOARDS_CONSTANTS = {
  BASE_URL: "/details",
  BLUE: "blue",
  CATEGORY: "category",
  CURRENT_PAGE: 1,
  COLUMN_LENGTH: 1,
  DATE: "date",
  EMAIL: "email",
  INITIAL_TAB: 0,
  JOB_DETAIL_URL: "/admin/jobs",
  JOB_DETAIL_VIEW: "/admin/jobs/",
  JOB_ID: "job_id",
  JOB_TYPE: "job",
  LENGTH_OF_DATA: 0,
  NAME: "name",
  NAVIGATE_BACK_PAGE: -1,
  OFFICE_DETAIL_URL: "/admin/office-users",
  OFFICE_TYPE: "office",
  ORANGE: "orange",
  PAGE_SIZE: {
    TEN: 10,
    TWENTY: 20,
    FIFTY: 50,
    HUNDRED: 100,
  },
  PROFESSIONAL_DETAIL_URL: "/admin/professional-users",
  PROFESSIONAL_TYPE: "professional",
  SET_PAGE: 1,
  SORT_DESC: "DESC",
  STATE: "state",
  TAB: "tab",
  TAB_PARAM: 10,
  TAB_INITIAL_QUERY: "?tab=",
  TAB_QUERY: "?tab=0",
  TAB_INDEX_FIRST: "?tabIndex=0",
  TAB_INDEX_SECOND: "?tabIndex=1",
  TYPE: 1,
  URL_JOBS: "/admin/jobs",
  URL_OFFICE: "/admin/office-users",
  URL_PROFESSIONAL: "/admin/professional-users",
  VIEW_INITIAL_TAB: 0,
};
